import { render } from "./TooltipComponent.vue?vue&type=template&id=60fab256&ts=true"
import script from "./TooltipComponent?vue&type=script&lang=ts"
export * from "./TooltipComponent?vue&type=script&lang=ts"

import "./_assets/_Tooltip.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__